import { StoreIcon, TruckIcon } from '@grupoboticario/flora-react-icons';
import { Card } from 'ui/components/primitives';
import { Address } from './Summary.components.styles';
import type { AddressMapper, AddressProps } from './Summary.components.d';

const addressTemplate = (address: string, isWithdrawal?: boolean) => (
  <>
    <Address.Title>
      {isWithdrawal ? (
        <>
          <StoreIcon size={24} /> Endereço de retirada
        </>
      ) : (
        <>
          <TruckIcon size={24} />
          Endereço de recebimento
        </>
      )}
    </Address.Title>
    <Card radius="rounded">
      <Address.Row tabIndex={0} aria-label={address}>
        <Address.Text>{address?.toLowerCase()}</Address.Text>
      </Address.Row>
    </Card>
  </>
);

export const addressMapper: AddressMapper = {
  1: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  9: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  16: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  13: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  18: ({ distributionCenterAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(distributionCenterAddress, isWithdrawal),
  23: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  25: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  26: ({ fullAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(fullAddress, isWithdrawal),
  28: ({ distributionCenterAddress = '', isWithdrawal }: AddressProps) =>
    addressTemplate(distributionCenterAddress, isWithdrawal),
};
